import { listAdminGroupChatMessageReads } from '../../../../api/adminGroupChat';
import { listAdminEventChatMessageReads } from '../../../../api/eventChat';

const validateReadStatusParams = ({ scope = 'event', eventId, threadId, messageId }) => {
  if (!messageId) throw new Error('messageId is required');
  if (scope === 'group') {
    if (!threadId) throw new Error('threadId is required');
    return;
  }
  if (!eventId) throw new Error('eventId is required');
};

export const fetchChatMessageReadStatusDetails = async (params) => {
  validateReadStatusParams(params);
  const { scope = 'event', eventId, threadId, messageId } = params;
  if (scope === 'group') {
    return listAdminGroupChatMessageReads(threadId, messageId);
  }
  return listAdminEventChatMessageReads(eventId, messageId);
};
